module.exports = require('./helpers/bundle-url').getBundleURL('9zxOH') + "logo-dark.eefe0b7f.svg";